import React from "react";
import AniLink from "gatsby-plugin-transition-link/AniLink";
import SocialShare from "./social-share";

import { pageTransition } from "../lib/transition-config";
import { getProjectUrl, cn } from "../lib/helpers";
import arrowPrev from "../images/Capacity_Arrow_Previous.svg";
import arrowNext from "../images/Capacity_Arrow_Next.svg";

import styles from "./project.module.css";
import PageSections from "./page-sections";

function Project(props) {
  const { _rawContent, content, adjacentSlugs } = props;

  const sectionContent = _rawContent ? _rawContent : content;

  return (
    <article className={styles.root}>
      <PageSections content={sectionContent} />
      <div className={styles.projectFooter}>
        <SocialShare />
        <div className={styles.arrows}>
          {adjacentSlugs && adjacentSlugs.previous && (
            <AniLink
              {...pageTransition}
              direction="left"
              className={cn(styles.adjacentLink, styles.prevLink)}
              to={getProjectUrl(adjacentSlugs.previous.slug.current)}
            >
              <img src={arrowPrev} alt="Previous" />
              <span>Previous</span>
            </AniLink>
          )}
          {adjacentSlugs && adjacentSlugs.next && (
            <AniLink
              {...pageTransition}
              className={cn(styles.adjacentLink, styles.nextLink)}
              to={getProjectUrl(adjacentSlugs.next.slug.current)}
            >
              <span>Next</span>
              <img src={arrowNext} alt="Next" />
            </AniLink>
          )}
        </div>
      </div>
    </article>
  );
}

export default Project;
